import React, { Component } from 'react';
import classNames from 'classnames';
import Heading from '../../components/heading';
import Account from '../../components/account';
import SaveButton from '../../components/report/save-button';
import withAuthProvider from '../../hoc/withAuthProvider';
import SpinnerDots from '../../components/spinner/dots';
import { REACT_APP_API_BASE } from '../../config';
import withFetch from '../../hoc/withFetch';
import { Select } from '../../components/forms';
import '../monitor/styles.scss';
import './styles.scss';

class Profile extends Component {
    
    state = {
        isLoading: true,
        profile: null
    }

    async componentDidUpdate() {
        if (!this.props.isAuthenticated) return;

        if (this.state.profile) return;

        const res = await this.props.fetch(`${REACT_APP_API_BASE}/online/profile`);
        const profile = await res.json();

        this.setState({
            isLoading: false,
            profile
        });
    }

    updateValue(value, name) {
        const profile = {...this.state.profile};
        profile[name] = value;
        this.setState({
            profile
        });
    }  

    async save(e) {
        e.preventDefault();

        this.setState({
            isSaving: true
        });

        const token = await this.props.getAccessToken();
        const headers = new Headers();
        const bearer = `Bearer ${token}`;
        headers.append('Authorization', bearer);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');

        const rawResponse = await fetch(`${REACT_APP_API_BASE}/online/profile`, {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify({
                ...this.state.profile
            })
        });

        if (rawResponse.ok) {
            const profile = await rawResponse.json();

            this.setState({
                isSaved: true,
                isSaving: false
            }, () => {
                this.setState({
                    ...profile
                });
                setTimeout(() => {
                    this.setState({
                        isSaved: false
                    });
                }, 1500);
            });            
        } else {
            this.setState({
                isSaving: false,
                error: { message: 'Kunde inte spara profil' }
            });
        }
    }

    render() {
        
        return (
            <section className={classNames({
                'monitor': true,
                'profile': true,
                'profile--is-saving': this.state.isSaving,
                'profile--is-loading': this.state.isLoading
            })}>
                <Heading heading="Mitt konto" />
                <div className="profile__content">
                    <div className="profile__content-inner">
                        <div className="profile__content-inner-content">
                            <Account profile={this.state.profile} />
                            {this.state.profile &&
                                <>
                                    <h2 className="profile__heading">Mina uppgifter</h2>
                                    <form className="profile__form" onSubmit={(e) => this.save(e)}>
                                        <div className="profile__form-container">
                                            <div className="profile__form-split-col">
                                                <label className="profile__form-label">E-post</label>
                                                <div>{this.state.profile.email}</div>
                                            </div>
                                        </div>
                                        <div className="profile__form-container">
                                            <div className="profile__form-split-col">
                                                <label className="profile__form-label" htmlFor="firstname">Namn</label>
                                                <input id="firstname" name="name" type="text" defaultValue={this.state.profile.name} onChange={(e) => this.updateValue(e.currentTarget.value, 'name')} />
                                            </div>
                                            <div className="profile__form-split-col">
                                                <label className="profile__form-label" htmlFor="jobTitle">Befattning</label>
                                                <Select name="jobTitle" id="jobTitle" onChange={(e) => this.updateValue(e.currentTarget.value === '' ? null : e.currentTarget.value, 'jobTitle')} value={!this.state.profile.jobTitle ? '' : this.state.profile.jobTitle}>
                                                    <option value="">Välj</option>
                                                    {this.state.profile.availableJobTitles.map((title, i) => {
                                                        return (
                                                            <option key={`${title}${i}`} value={title}>{title}</option>
                                                        );
                                                    })}
                                                </Select>
                                            </div>
                                        </div>
                                        <div className="profile__form-container">
                                            <div className="profile__form-split-col">
                                                <label className="profile__form-label" htmlFor="mobilePhone">Direkt-/Mobilnummer</label>
                                                <input id="mobilePhone" name="mobilePhone" type="text" value={this.state.profile.mobilePhone} onChange={(e) => this.updateValue(e.currentTarget.value, 'mobilePhone')} />
                                            </div>
                                            <div className="profile__form-split-col">
                                                <label className="profile__form-label" htmlFor="workPhone">Växelnummer</label>
                                                <input id="workPhone" name="workPhone" type="text" value={this.state.profile.workPhone} onChange={(e) => this.updateValue(e.currentTarget.value, 'workPhone')} />
                                            </div>
                                        </div>
                                        <div className="profile__form-container">
                                            <div className="profile__form-footer">
                                                <SaveButton type="submit"
                                                    isLoading={this.state.isSaving}
                                                    isSaved={this.state.isSaved} 
                                                    text="Spara mina uppgifter" 
                                                    textSaving="Sparar uppgifterna"
                                                    textSaved="Uppgifterna sparades!" 
                                                    modifiers={{
                                                        'profile__save': true
                                                    }}
                                                    attr={{
                                                        disabled: this.state.isSaving
                                                    }} />
                                            </div>
                                        </div>
                                    </form>
                                </>
                            }
                        </div>
                    </div>
                </div>
                <SpinnerDots />
            </section>
        );
    }
};

export default withAuthProvider(withFetch(Profile));